import React, { createContext, forwardRef, useContext, useEffect, useRef, useState, } from "react";
import { Tabs } from "../ui/ot"

const CrmCategoryMenu1_1 = ({
    showComponent = ["Tabs"],
    TabsProps = {
        activeKey: '',
        defaultActiveKey: '',
        items: [
            {
                key: 'new',
                tab: '空白文案與AI生成',
                content: '',
            },
            {
                key: 'deafult',
                tab: '系統預設文案',
                content: '',
            },
        ],
        onChange: () => { },
        centered: false,
        tabBarExtraContent: "",
        tabsStyle: {
            width: "100%",        // w-full
            paddingLeft: "1rem",  // px-4 → 1rem
            paddingRight: "1rem",
            paddingBottom: "1rem" // pb-4 → 1rem
        },
        tabsListStyle: {
            display: "grid",                                      // grid
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",     // grid-cols-2
            backgroundColor: "#ccfbf1"                            // bg-teal-100
        },
        tabsTriggerStyle: {
            display: "flex",        // flex
            flexDirection: "column",// flex-col
            height: "auto"          // h-auto
        },
        showRenderFunction: false,
        renderFunction: () => { },
    }
}) => {

    return (
        <>
            {
                showComponent.includes("Tabs") && (
                    <Tabs {...TabsProps} />
                )
            }
        </>
    )
}
export default CrmCategoryMenu1_1